import { render, staticRenderFns } from "./SsoInitiate.vue?vue&type=template&id=410f4f0c&scoped=true"
import script from "./SsoInitiate.vue?vue&type=script&lang=js"
export * from "./SsoInitiate.vue?vue&type=script&lang=js"
import style0 from "./SsoInitiate.vue?vue&type=style&index=0&id=410f4f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f4f0c",
  null
  
)

export default component.exports